// 后端需要的默认节点数据
export const defaultNode: any = {
  actions: ['PASS', 'REJECT'],
  timeoutConfig: {
    enable: false,
    value: 'not'
  },
  approvalRule: 'ANY',
  approvalType: 'NORMAL',
  permissions: {},
  missingCandidates: [],
  missingApproverRule: 'NEXT',
  triggerAction: ['NEW', 'EDIT'],
  notifyConfig: {
    enable: true,
    type: 'CUSTOM',
    channels: ['PLATFORM'],
    customMessage: {
      PROCESS_APPROVAL_NOTIFY: [
        { type: 'CONTENT', content: '您有一笔待处理的「' },
        { type: 'APP_NAME', content: '' },
        { type: 'CONTENT', content: '」数据，请及时处理！' }
      ],
      PROCESS_APPROVAL_TIMEOUT_NOTIFY: [
        { type: 'CONTENT', content: '您有一笔“已超时”的待处理「' },
        { type: 'APP_NAME', content: '' },
        { type: 'CONTENT', content: '」数据，请及时处理！' }
      ]
    }
  },
  dataTitleMapping: {
    tableCode: '',
    columnSerial: []
  }
}

export function getDefaultConfig(appCode: string) {
  return [
    {
      shape: 'customer-edge',
      id: 'edge-0',
      zIndex: -1,
      source: {
        cell: '0',
        port: '3'
      },
      target: {
        cell: '1',
        port: '0'
      },
      labels: ['线1'],
      attrs: {
        rect: {
          fill: '#F4F4F5'
        },
        text: {
          fill: '#666'
        }
      },
      data: {
        name: '线1',
        def: true,
        order: 1
      }
    },
    {
      shape: 'customer-edge',
      id: 'edge-1',
      zIndex: -1,
      source: {
        cell: '1',
        port: '3'
      },
      target: {
        cell: '-1',
        port: '0'
      },
      labels: ['线2'],
      data: {
        name: '线2',
        def: true,
        order: 1
      }
    },
    {
      position: {
        x: 400,
        y: 30
      },
      size: {
        width: 88,
        height: 38
      },
      attrs: {
        text: {
          text: '流程开始'
        }
      },
      visible: true,
      shape: 'rect',
      data: {
        type: 'STRUCT',
        flag: 'START',
        name: '流程开始',
        appCode
      },
      ports: {
        groups: {
          top: {
            position: 'top',
            attrs: {
              circle: {
                r: 4,
                magnet: true,
                stroke: 'red',
                strokeWidth: 1,
                fill: 'red',
                class: 'start-port'
              }
            }
          },
          bottom: {
            position: {
              name: 'bottom'
            },
            attrs: {
              circle: {
                r: 4,
                magnet: true,
                stroke: 'red',
                strokeWidth: 1,
                fill: 'red',
                class: 'start-port'
              }
            }
          },
          left: {
            position: {
              name: 'left'
            },
            attrs: {
              circle: {
                r: 4,
                magnet: true,
                stroke: 'red',
                strokeWidth: 1,
                fill: 'red',
                class: 'start-port'
              }
            }
          },
          right: {
            position: {
              name: 'right'
            },
            attrs: {
              circle: {
                r: 4,
                magnet: true,
                stroke: 'red',
                strokeWidth: 1,
                fill: 'red',
                class: 'start-port'
              }
            }
          }
        },
        items: [
          {
            group: 'top',
            id: '0',
            attrs: {
              circle: {
                fill: '#fff',
                stroke: '#85A5FF'
              }
            }
          },
          {
            group: 'bottom',
            id: '3',
            attrs: {
              circle: {
                fill: '#fff',
                stroke: '#85A5FF'
              }
            }
          },
          {
            group: 'left',
            id: '1',
            attrs: {
              circle: {
                fill: '#fff',
                stroke: '#85A5FF'
              }
            }
          },
          {
            group: 'right',
            id: '2',
            attrs: {
              circle: {
                fill: '#fff',
                stroke: '#85A5FF'
              }
            }
          }
        ]
      },
      id: '0',
      zIndex: 1
    },
    {
      position: {
        x: 400,
        y: 530
      },
      size: {
        width: 88,
        height: 38
      },
      attrs: {
        text: {
          fill: '#fff',
          text: '流程结束'
        },
        body: {
          fill: '#617198'
        }
      },
      visible: true,
      shape: 'rect',
      ports: {
        groups: {
          top: {
            position: 'top',
            attrs: {
              circle: {
                r: 4,
                magnet: true,
                stroke: 'red',
                strokeWidth: 1,
                fill: 'red',
                class: 'start-port'
              }
            }
          },
          bottom: {
            position: {
              name: 'bottom'
            },
            attrs: {
              circle: {
                r: 4,
                magnet: true,
                stroke: 'red',
                strokeWidth: 1,
                fill: 'red',
                class: 'start-port'
              }
            }
          },
          left: {
            position: {
              name: 'left'
            },
            attrs: {
              circle: {
                r: 4,
                magnet: true,
                stroke: 'red',
                strokeWidth: 1,
                fill: 'red',
                class: 'start-port'
              }
            }
          },
          right: {
            position: {
              name: 'right'
            },
            attrs: {
              circle: {
                r: 4,
                magnet: true,
                stroke: 'red',
                strokeWidth: 1,
                fill: 'red',
                class: 'start-port'
              }
            }
          }
        },
        items: [
          {
            group: 'top',
            id: '0',
            attrs: {
              circle: {
                fill: '#fff',
                stroke: '#85A5FF'
              }
            }
          },
          {
            group: 'bottom',
            id: '3',
            attrs: {
              circle: {
                fill: '#fff',
                stroke: '#85A5FF'
              }
            }
          },
          {
            group: 'left',
            id: '1',
            attrs: {
              circle: {
                fill: '#fff',
                stroke: '#85A5FF'
              }
            }
          },
          {
            group: 'right',
            id: '2',
            attrs: {
              circle: {
                fill: '#fff',
                stroke: '#85A5FF'
              }
            }
          }
        ]
      },
      data: {
        type: 'STRUCT',
        flag: 'END',
        name: '流程结束',
        appCode
      },
      id: '-1',
      zIndex: 1
    },
    {
      position: {
        x: 354,
        y: 180
      },
      size: {
        width: 180,
        height: 88
      },
      view: 'vue-shape-view',
      attrs: {
        body: {
          fill: '#fff',
          stroke: '#8f8f8f',
          strokeWidth: 1
        }
      },
      shape: 'flow-approval-comp',
      ports: {
        groups: {
          top: {
            position: 'top',
            attrs: {
              circle: {
                r: 4,
                magnet: true,
                stroke: 'red',
                strokeWidth: 1,
                fill: 'red',
                class: 'haha-cussss'
              }
            }
          },
          bottom: {
            position: {
              name: 'bottom'
            },
            attrs: {
              circle: {
                r: 4,
                magnet: true,
                stroke: 'red',
                strokeWidth: 1,
                fill: 'red'
              }
            }
          },
          left: {
            position: {
              name: 'left'
            },
            attrs: {
              circle: {
                r: 4,
                magnet: true,
                stroke: 'red',
                strokeWidth: 1,
                fill: 'red'
              }
            }
          },
          right: {
            position: {
              name: 'right'
            },
            attrs: {
              circle: {
                r: 4,
                magnet: true,
                stroke: 'red',
                strokeWidth: 1,
                fill: 'red'
              }
            }
          }
        },
        items: [
          {
            group: 'top',
            id: '0',
            attrs: {
              circle: {
                fill: 'transparent',
                stroke: 'transparent'
              }
            }
          },
          {
            group: 'bottom',
            id: '3',
            attrs: {
              circle: {
                fill: 'transparent',
                stroke: 'transparent'
              }
            }
          },
          {
            group: 'left',
            id: '1',
            attrs: {
              circle: {
                fill: 'transparent',
                stroke: 'transparent'
              }
            }
          },
          {
            group: 'right',
            id: '2',
            attrs: {
              circle: {
                fill: 'transparent',
                stroke: 'transparent'
              }
            }
          }
        ]
      },
      id: '1',
      data: {
        label: '审批节点',
        icon: 'copy',
        name: '审批节点',
        type: 'APPROVAL',
        appCode,
        ...defaultNode
      }
    }
  ]
}
